import ParkPassAPI from "../parkpassAxiosConfig";

export const getParkingTickets = async (params = {}) => {
  try {
    const {
      page = 1,
      pageSize = 20,
      statusFilter,
      matricule,
      startTimeFrom,
      startTimeEnd,
      userId,
    } = params;

    const queryParams = {
      page,
      page_size: pageSize,
    };

    if (statusFilter) queryParams.status_filter = statusFilter;
    if (matricule) queryParams.matricule = matricule;
    if (startTimeFrom) queryParams.start_time_from = startTimeFrom;
    if (startTimeEnd) queryParams.start_time_end = startTimeEnd;
    if (userId) queryParams.user_id = userId;

    const response = await ParkPassAPI.get("/v1/parking/tickets/admin", {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
